import React from 'react';
import '../../styles/certifii.css';
import CERTIFII_CONTENT from '../components/landingPage/CertifiiPage/certifiiContent';
import {
    CertifiiHeader, CertifiiHero, CertifiiHeroInvestor, CertifiiBenefits, CertifiiFlow,
    CertifiiCti, CertifiiTiers, CertifiiScreens, CertifiiPricing, CertifiiPricingInvestor,
    CertifiiFinal,
} from '../components/landingPage/CertifiiPage/CertifiiSections';

/**
 * Diligentsia x Certifii — the Financial tab destination, opened in a new browser tab.
 *
 * One page serves all three personas. Six sections are shared and driven by CERTIFII_CONTENT;
 * the rest vary by audience:
 *   - hero / pricing — company and advisor share a layout, investor has its own
 *   - tiers          — company only ("Choose where to start")
 *   - screens        — advisor and investor only (CTI dashboard screenshots)
 *
 * @param {'company'|'advisor'|'investor'} persona - which audience this page addresses
 */
const CertifiiPage = ({ persona = 'company' }) => {
    const c = CERTIFII_CONTENT[persona] || CERTIFII_CONTENT['company'];
    const isInvestor = persona === 'investor';

    return (
        // `is-investor` scopes the three CSS rules whose values differ from the other personas.
        <div className={`dlg-certifii-module${isInvestor ? ' is-investor' : ''}`}>
            <CertifiiHeader />
            {isInvestor ? <CertifiiHeroInvestor /> : <CertifiiHero c={c['CertifiiHero']} />}
            <CertifiiBenefits c={c['CertifiiBenefits']} />
            <CertifiiFlow c={c['CertifiiFlow']} />
            <CertifiiCti c={c['CertifiiCti']} />
            {persona === 'company' && <CertifiiTiers />}
            {persona !== 'company' && <CertifiiScreens c={c['CertifiiScreens']} />}
            {isInvestor ? <CertifiiPricingInvestor /> : <CertifiiPricing c={c['CertifiiPricing']} />}
            <CertifiiFinal c={c['CertifiiFinal']} />
        </div>
    );
};

export default CertifiiPage;
